/** Evenly spaced port centers: N ports → N+1 equal segments along the edge. */
export function centeredHandleTopsPx(heightPx: number, count: number): number[] {
	const height = Math.max(heightPx, 1);
	if (count <= 1) return [height / 2];
	return Array.from({ length: count }, (_, i) => (height * (i + 1)) / (count + 1));
}

export function handleStyleAtPx(topPx: number, side: 'left' | 'right', color?: string): string {
	const transform = side === 'left' ? 'translate(-50%, -50%)' : 'translate(50%, -50%)';
	const bg = color ? ` background: ${color};` : '';
	return `top: ${Math.round(topPx)}px; transform: ${transform};${bg}`;
}

export function inputHandleStyleFromHeight(heightPx: number): string {
	return handleStyleAtPx(centeredHandleTopsPx(heightPx, 1)[0], 'left');
}

export function outputHandleStyleFromHeight(heightPx: number, color?: string): string {
	return handleStyleAtPx(centeredHandleTopsPx(heightPx, 1)[0], 'right', color);
}

/** Green / red branch outputs on the right (one or two ports). */
export function branchOutputHandleStyles(
	heightPx: number,
	hideFalse: boolean,
): { true: string; false?: string } {
	const count = hideFalse ? 1 : 2;
	const tops = centeredHandleTopsPx(heightPx, count);
	return {
		true: handleStyleAtPx(tops[0], 'right', '#22c55e'),
		false: hideFalse ? undefined : handleStyleAtPx(tops[1], 'right', '#ef4444'),
	};
}

/** Multiple handles on either edge, all using the same centering rule. */
export function multiHandleStyle(
	side: 'left' | 'right',
	index: number,
	count: number,
	heightPx: number,
	color: string,
): string {
	const tops = centeredHandleTopsPx(heightPx, count);
	return handleStyleAtPx(tops[index] ?? tops[0], side, color);
}

export function multiInputHandleStyle(
	index: number,
	count: number,
	heightPx: number,
	color: string,
): string {
	return multiHandleStyle('left', index, count, heightPx, color);
}

export type FlowBranchOutputs = false | 'true-only' | 'true-false';

export type FlowNodePort = {
	id: string;
	color?: string;
	label?: string;
	/** Pin a port to the exact vertical center without relying on measured height. */
	centered?: boolean;
	/** Optional element within the node whose vertical center should anchor this port. */
	alignSelector?: string;
};
